<template>
  <!-- <div class="container-fluid login"> -->
  <!-- <div class="row d-flex align-items-center h-100">
      <div class="col-12 d-flex justify-content-center">
        <div class="w-md-30" :class="reset ? 'bg-white p-5' : ''">
          <a class="auth-brand text-center d-block mb-20" href="#">
            <img
              class="brand-img w-100"
              src="@/assets/img/odin.png"
            
              alt="Odin"
            />
          </a>
          <form @submit.prevent="login" v-if="!reset">
            <h1 class="display-4 text-center mb-10 f-default">Bem Vindo</h1>
            <p class="text-center mb-30 f-default">Realize o login para continuar</p>
            <div class="form-group">
              <input
                class="form-control f-default"
                id="username"
                name="username"
                v-model="credentials.username"
                placeholder="Usuário"
                type="text"
              />
            </div>
            <div class="form-group">
              <div class="input-group">
                <input
                  class="form-control f-default"
                  id="password"
                  name="password"
                  v-model="credentials.password"
                  placeholder="Senha"
                  type="password"
                />
              </div>
            </div>
            <button
              class="btn btn-teal btn-block mb-3 f-default"
              type="submit"
              :disabled="captch === ''"
            >
              Login
            </button>

            <a
              href="#"
              class="text-center w-100 d-flex justify-content-center f-default"
              @click="
                reset = !reset;
                captch = '';
              "
              >Esqueci minha senha</a
            >
            <vue-recaptcha
              sitekey="6LfAFfEUAAAAAGl7-UBeTrFv9mHwdiMBAtwyWa87"
              :loadRecaptchaScript="true"
              @verify="verifyRecaptcha"
              class="d-flex justify-content-center mt-4"
            >
            </vue-recaptcha>
          </form>

          <form @submit.prevent="resetPw" method="post" v-else>
            <h1 class="display-5 mb-10 text-center f-default">
              Precisa de ajuda com a sua senha?
            </h1>
            <p class="mb-30 text-center f-default" style="color: #5e7d8a">
              Nos lhe enviaremos um email com um link de registro para uma nova
              senha.
              <br />
              Preencha seu email de usuário do sistema logo abaixo.
            </p>
            <div class="form-group">
              <input
                class="form-control f-default"
                placeholder="Email"
                type="email"
                name="login"
                v-model="credentials.username"
              />
            </div>
            <vue-recaptcha
              sitekey="6LfAFfEUAAAAAGl7-UBeTrFv9mHwdiMBAtwyWa87"
              :loadRecaptchaScript="true"
              @verify="verifyRecaptcha"
              class="d-flex justify-content-center mt-4 f-default"
            >
            </vue-recaptcha>
            <button
              class="btn btn-info btn-block mb-20 mt-4 f-default"
              type="submit"
              :disabled="captch === ''"
            >
              Enviar
            </button>
            <p class="text-right f-default">
              <a href="#" @click="reset = !reset">Voltar para tela de login</a>
            </p>
          </form>
        </div>
      </div>
    </div> -->
  <!-- </div> -->
  <b-container fluid>
    <b-row>
      <b-col cols="12" lg="6" xl="4" class="bg d-flex align-items-center">
        <b-container class="">
          <b-row class="text-center d-flex justify-content-center">
            <b-col cols="12" class="d-flex justify-content-center">
              <img src="@/assets/img/svgs/logo_diazero.svg" alt="" />
            </b-col>
            <b-col cols="12" class="my-4">
              <h2 class="f-default">A Evolução da Segurança</h2>
            </b-col>
            <b-col cols="9" class="">
              <p class="f-default">
                Para a Diazero Security não se trata apenas de uma prestação de
                serviço, nossos especialistas buscam trabalhar em conjunto com a
                sua equipe com foco na solução de seus problemas, atendendo a
                todas as suas necessidades.
              </p>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
      <b-col cols="12" lg="6" xl="8" class="d-flex align-items-center login">
        <b-container @submit.prevent="login" tag="form">
          <b-row class="text-center d-flex justify-content-center">
            <b-col cols="12" md="6">
              <h1 class="f-default">
                {{
                  !reset
                    ? "Seja Bem-vindo!"
                    : "Precisa de ajuda com a sua senha?"
                }}
              </h1>
            </b-col>
            <b-col cols="12" md="7">
              <p class="f-default">
                {{
                  !reset
                    ? "Realize o login para continuar"
                    : `Nos lhe enviaremos um email com um link de registro para uma nova senha.
Preencha seu email de usuário do sistema logo abaixo.`
                }}
              </p>
            </b-col>
            <b-col cols="7">
              <b-form-input
                v-model="credentials.username"
                type="email"
                :class="{ 'my-3': reset }"
                placeholder="Usuário"
              />
            </b-col>
            <b-col cols="7">
              <b-form-input
                v-model="credentials.password"
                type="password"
                placeholder="Senha"
                class="my-3"
                v-if="!reset"
              />
            </b-col>
            <b-col cols="7" class="mb-2">
              <b-button class="w-100 btn-black" type="submit">{{
                !reset ? "Login" : "Recuperar"
              }}</b-button>
            </b-col>
            <b-col cols="7">
              <a
                href="#"
                class="
                  text-center
                  w-100
                  d-flex
                  justify-content-center
                  f-default
                "
                @click="
                  reset = !reset;
                  captch = '';
                "
                >{{
                  !reset ? "Esqueci minha senha" : "Voltar para tela de login"
                }}</a
              >
            </b-col>

            <b-col cols="7">
              <vue-recaptcha
                sitekey="6LfAFfEUAAAAAGl7-UBeTrFv9mHwdiMBAtwyWa87"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                class="d-flex justify-content-center mt-4"
              />
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from "@/services/api";
import { mixins } from "@/mixins/mixins";
import Swal from "sweetalert2";

export default {
  props: [],
  mounted() {},
  mixins: [mixins],
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Login",
    // all titles will be injected into this template
    titleTemplate: "%s | Loki",
  },
  data() {
    return {
      credentials: {},
      loading: false,
      captch: "",
      reset: false,
    };
  },
  methods: {
    async login() {
      if (this.captch === "" && process.env.NODE_ENV === 'production') return;
      this.$store.commit("utils/setLoading", true);
      try {
        if (!this.reset) {
          await api.auth(this.credentials, this.captch);
          this.$router.push({ path: "/loki" });
          this.$store.commit("utils/setOpenNav", true);
        } else {
          await api.lostPassword(this.credentials.username, this.captch);
          Swal.fire({
            title: "Sucesso !",
            text: "Em breve você recebera um e-mail com as instruções",
            icon: "success",
          });
          this.reset = false;
          this.$store.commit("utils/setLoading", false);
        }
      } catch (error) {
        this.errorCatch(error);
        this.$store.commit("utils/setLoading", false);
      }
    },

    verifyRecaptcha(e) {
      this.captch = e;
    },
  },
  computed: {},
};
</script>

<style lang="scss" >
.bg {
  background-image: url("~@/assets/img/bg_login.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  h2 {
    font-style: normal;
    font-weight: normal;
    font-size: 56px;
    line-height: 66px;
    color: #fff;
  }
  p {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
  }
}
.login {
}
</style>
